import Vue from 'vue'

export default {
    send(params) {
        return Vue.axios.post(`/notifications/send`, params)
    },
    sendPreview(params) {
        return Vue.axios.post(`/notifications/send-preview`, params)
    },
    getFormDetails() {
        return Vue.axios.get(`/notifications-form-details`)
    },
    log(params) {
        return Vue.axios.get(`/notifications-log`, {params})
    }
}
